
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ApplicationAttachmentState extends BaseYcState {

}
